import { render, staticRenderFns } from "./LogoIcon.vue?vue&type=template&id=946a2564&scoped=true&"
import script from "./LogoIcon.vue?vue&type=script&lang=js&"
export * from "./LogoIcon.vue?vue&type=script&lang=js&"
import style0 from "./LogoIcon.vue?vue&type=style&index=0&id=946a2564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946a2564",
  null
  
)

export default component.exports